export default __webpack_public_path__ + "static/about-shape1-55551bf3d21f6c20374c6e9dca82fe4d.png";